module.exports = __webpack_public_path__ + "img/huawuIcon7.b3a94c0b.png";